/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 21/11/2023
 */

import React from "react";
import styles from "./Management.module.css";
import {
  Box,
  Button,
  Paper,
  Toolbar,
  Container,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useDispatch } from "react-redux";
import SearchBar from "../Components/Shared/SearchBar";
import ResourceDialog from "../Components/Resource/ResourceDialog";
import ResourceList from "../Components/Resource/ResourceList";
import { useGetAllResourceQuery } from "../Store/Services/ResourceService";
import { openAddResourceModal } from "../Store/Slices/resourceSlice";

const ResourceManagement = () => {
  const dispatch = useDispatch();
  const [searchData, setSearchData] = useState([]);
  const { data: resource, isSuccess, isLoading } = useGetAllResourceQuery();

  const roles = sessionStorage.getItem("roles");
  
  return (
    roles?.split(",").includes("PRIV_ES_DISPLAY_RESOURCE") ? (
    <Paper elevation={3} className={styles.pageContainer} style={{backgroundImage: `url(${process.env.REACT_APP_IMAGE_URL}E_SERVICE/thumbnail_Management.png)`}}>
      <Box>
        <Toolbar className={styles.subNavBar}>
          <Typography className={styles.topic}>Resource Management</Typography>
          {roles?.split(",").includes("PRIV_ES_ADD_RESOURCE") ?  (<Button
            variant="contained"
            color="primary"
            className={styles.buttonItem}
            onClick={() => dispatch(openAddResourceModal())}
          >
            Add Resource
          </Button>) : null}
        </Toolbar>
      </Box>

      <Container id={styles.container}>
        <SearchBar
          data={resource || []}
          setSearchData={setSearchData}
          text="Search Resources"
          search="resource"
        />
      </Container>

      <Container>
     <ResourceList data={searchData } />
        {/* <ResourceList /> */}
      </Container>

      <ResourceDialog />
    </Paper> ) : null
  );
};

export default ResourceManagement;
